import axios from 'axios';
import { ENDPOINTS } from './endpoints';

export const viewClassWiseResultAnalysis = async (program_id, exam_type) => {
  try {
    const response = await axios.get(`${ENDPOINTS.RESULT.CLASS_WISE}?program_id=${program_id}&exam_type=${exam_type}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export const viewTeacherWiseResultAnalysis = async (teacher_id, exam_type) => {
  try {
    const response = await axios.get(`${ENDPOINTS.RESULT.TEACHER_WISE}?teacher_id=${teacher_id}&exam_type=${exam_type}`);
    return response;
  } catch (error) {
    throw error;
  }
}

export const getClassResultJson = async (program_id, term_id, markingType, excel, subjectIds) => {
  try {
    const params = new URLSearchParams();
    if (markingType === "calculated") params.append("flag", "calculated");
    if (subjectIds?.length) params.append("subject_ids", subjectIds.join(","));
    if (excel) params.append("excel", 1);
    const query = params.toString() ? `?${params.toString()}` : "";
    const config = excel ? { responseType: "arraybuffer" } : undefined;
    const response = await axios.get(`${ENDPOINTS.RESULT.CLASS_RESULT_JSON}/${program_id}/${term_id}${query}`, config);
    return response;
  } catch (error) {
    throw error;
  }
}

export const cbseResult = async (formData) => {
  const axiosConfig = {
    method: 'post',
    url: ENDPOINTS.RESULT.CBSE_RESULT,
    data: formData,
    headers: { "Content-Type": "multipart/form-data" }
  };

  try {
    const response = await axios(axiosConfig)
    return response;
  } catch (error) {
    throw error;
  }
}
